import { handleResponse, handleError, headerset } from "../apiUtils";

const baseUrl = (endpoint: string, id?: number) => {
    let url = `${process.env.API_URL}/api/anagrafiche/${endpoint}/`;

    if (id) {
        url += `${id}/`;
    }

    return url;
};

// Commerciali
export function fetchCommerciali() {
    const url = baseUrl('commerciali');

    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}

// Mandatari
export function fetchSoggetti() {
    const url = baseUrl('soggetti');

    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}

// Stagioni
export function fetchStagioni() {
    const url = baseUrl('stagioni');

    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}

// Tecniche
export function fetchTecniche() {
    const url = baseUrl('tecniche');

    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}

// Da aggiungere in anagraficheApi.ts

export function fetchMacchine() {
    const url = `${process.env.API_URL}/api/produzione/macchine/`;
    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}


export function fetchGiorniLavorativi(data_da: string, data_a: string) {
    const url = `${process.env.API_URL}/api/anagrafiche/giorni-lavorativi/?data_da=${data_da}&data_a=${data_a}`;

    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}